document.addEventListener( 'DOMContentLoaded', function () {
  
  $('.pageCollection').css('display', 'none');

  // ====== COLLECTION PAGE FUNCTIONS ====== //

  $('.quick-add').click(function(e) {

    e.preventDefault();

    var thisid = $(this).attr("id");

    //console.log(thisid);

    $("input[data-name=" + thisid + "]").trigger('click');

  });
  
  $(document).ready(function() {
    
    $(".product-select").on('click', function() {

      $(this).toggleClass("open");

    });

    $(".duration-select").on('click', function() {

      $(this).toggleClass("open");

  	});

    $( ".product-options input:first-child" ).trigger('click');
    $( ".duration-options input:first-child" ).trigger('click');
    
    //$(".radio1").trigger('click');
    //$(".duration1").trigger('click');

  });

  $(".radioInput").on('click', function() {

    var this_id = $(this).attr('id');
    var product_title = $("label[for=" + this_id + "]").html();
    
    var product_id = $(this).attr('id').split("-");
    
    //console.log(product_id[1]);

    $("#product-select-" + product_id[1]).toggleClass("open");
    $("#product-select-text-" + product_id[1]).html(product_title);

    /*var onetimeprice = "#onetime-" + $(this).val();
    var onemainprice = "#one-mainprice-" + $(this).val();
    var submainprice = "#sub-mainprice-" + $(this).val();
    var subscribeprice = "#subscribe-" + $(this).val();

    $(".onetime-price").removeClass("active");
    $(onetimeprice).addClass("active");

    $(".one-time").removeClass("active");
    $(onemainprice).addClass("active");

    $(".subscribe").removeClass("active");
    $(submainprice).addClass("active")

    $(".subscribe-price").removeClass("active");
    $(subscribeprice).addClass("active");*/
    
    $("#rc-container-wrapper-" + product_id[1] + " .rc_popup__hover").trigger('click');

  });

  $(".durationInput").on('click', function() {

    var this_id = $(this).attr('id');
    var product_title = $("label[for=" + this_id + "]").html();
    var durationval = $(this).val();
    var this_count = $(this).index();
    
    var product_id = $(this).attr('id').split("-");
    
    //console.log(product_id[1]);
    
    console.log(this_count);
    
    var this_count = this_count/2;
    var this_count = this_count - 1;

    //console.log(this_count);

    $("#duration-select-" + product_id[1]).toggleClass("open");
    $("#duration-select-text-" + product_id[1]).html(product_title);
    $('#subscription-' + product_id[1]).val(durationval);
    
    if (durationval != "false") {
      
      $("#rc-container-wrapper-" + product_id[1] + " input.rc_radio__autodeliver").trigger("click");
      
      $("#rc-container-wrapper-" + product_id[1] + " select.rc_select__frequency").children().removeAttr("selected");
      $("#rc-container-wrapper-" + product_id[1] + " select.rc_select__frequency option:eq( " + this_count + " )").attr('selected', 'selected');
      
    } else {
    
      $("#rc-container-wrapper-" + product_id[1] + " input.rc_radio__onetime").trigger("click");
      
    }
    
    //$('.rc_select').children().removeAttr("selected");
    //$('.rc_select option:eq(' + this_count + ')').attr('selected', 'selected');*/

  });
  
  $('.radioInput').on('change', function() {

    var the_value = $(this).val();
    var var_title = $(this).attr("data-variant-title");
    
    //console.log(the_value);
    //console.log(var_title);
    
    var product_id = $(this).attr('id').split("-");


    $("#the-code-" + product_id[1]).val(the_value);
    $("#variant-title-" + product_id[1]).val(var_title);

  });
  
  $('.pageCollection').css('display', 'block');

});